
import { Component, Vue } from 'vue-property-decorator'
import Day from './Day.vue'
import DayHeader from './DayHeader.vue'

@Component({
  components: {
    Day,
    DayHeader,
  },
})
export default class TimeTable extends Vue {
  days = [0, 1, 2, 3, 4]
}
